/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VisitorSessionState,
    VisitorSessionStateFromJSON,
    VisitorSessionStateFromJSONTyped,
    VisitorSessionStateToJSON,
    VisitorSessionVariable,
    VisitorSessionVariableFromJSON,
    VisitorSessionVariableFromJSONTyped,
    VisitorSessionVariableToJSON,
    VisitorSessionVisitedDeviceGroup,
    VisitorSessionVisitedDeviceGroupFromJSON,
    VisitorSessionVisitedDeviceGroupFromJSONTyped,
    VisitorSessionVisitedDeviceGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface VisitorSession
 */
export interface VisitorSession {
    /**
     * Unique id for the session
     * @type {string}
     * @memberof VisitorSession
     */
    readonly id?: string;
    /**
     * Exhibition id the visiotr was attending to
     * @type {string}
     * @memberof VisitorSession
     */
    readonly exhibitionId?: string;
    /**
     * 
     * @type {VisitorSessionState}
     * @memberof VisitorSession
     */
    state: VisitorSessionState;
    /**
     * 
     * @type {string}
     * @memberof VisitorSession
     */
    language: string;
    /**
     * 
     * @type {Array<VisitorSessionVariable>}
     * @memberof VisitorSession
     */
    variables?: Array<VisitorSessionVariable>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VisitorSession
     */
    visitorIds: Array<string>;
    /**
     * 
     * @type {Array<VisitorSessionVisitedDeviceGroup>}
     * @memberof VisitorSession
     */
    visitedDeviceGroups?: Array<VisitorSessionVisitedDeviceGroup>;
    /**
     * 
     * @type {string}
     * @memberof VisitorSession
     */
    readonly creatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof VisitorSession
     */
    readonly lastModifierId?: string;
    /**
     * Created date
     * @type {Date}
     * @memberof VisitorSession
     */
    readonly createdAt?: Date;
    /**
     * Date modified
     * @type {Date}
     * @memberof VisitorSession
     */
    readonly modifiedAt?: Date;
}

export function VisitorSessionFromJSON(json: any): VisitorSession {
    return VisitorSessionFromJSONTyped(json, false);
}

export function VisitorSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitorSession {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'exhibitionId': !exists(json, 'exhibitionId') ? undefined : json['exhibitionId'],
        'state': VisitorSessionStateFromJSON(json['state']),
        'language': json['language'],
        'variables': !exists(json, 'variables') ? undefined : ((json['variables'] as Array<any>).map(VisitorSessionVariableFromJSON)),
        'visitorIds': json['visitorIds'],
        'visitedDeviceGroups': !exists(json, 'visitedDeviceGroups') ? undefined : ((json['visitedDeviceGroups'] as Array<any>).map(VisitorSessionVisitedDeviceGroupFromJSON)),
        'creatorId': !exists(json, 'creatorId') ? undefined : json['creatorId'],
        'lastModifierId': !exists(json, 'lastModifierId') ? undefined : json['lastModifierId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (new Date(json['modifiedAt'])),
    };
}

export function VisitorSessionToJSON(value?: VisitorSession | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'state': VisitorSessionStateToJSON(value.state),
        'language': value.language,
        'variables': value.variables === undefined ? undefined : ((value.variables as Array<any>).map(VisitorSessionVariableToJSON)),
        'visitorIds': value.visitorIds,
        'visitedDeviceGroups': value.visitedDeviceGroups === undefined ? undefined : ((value.visitedDeviceGroups as Array<any>).map(VisitorSessionVisitedDeviceGroupToJSON)),
    };
}


